module.exports = __webpack_public_path__ + "static/Заявление_о_внесении_изменений_в_договор_об_открытии_и_ведении_счета-ba6bbc9ece0059cbec5d68ece253b866.pdf";